import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class SchoolService {

  constructor(private http: HttpClient) { }

  getLookupSchool(clientId) {
    let params = new HttpParams({
      fromObject: {
        clientId: clientId
      }
    });
    return this.http.get(
      '/api/school/lookup',
      { params }
    );
  }

  getLookupBus(clientId, schoolId) {
    let params = new HttpParams({
      fromObject: {
        clientId: clientId,
        schoolId: schoolId
      }
    });
    return this.http.get(
      '/api/bus/lookup',
      { params }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/school.service.ts